export const normalizeLowerTrim = (value) => String(value ?? '').trim().toLowerCase();

export const normalizeLowerTrimUnderscoreToSpace = (value) =>
    normalizeLowerTrim(value).replace(/_/g, ' ');

export const toTitleCase = (value = "") => (value || "")
    .toString()
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .filter(Boolean)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase())
    .join(" ");
